import { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";

import { setRemoveModalOpen } from "../store/action-creators";
import { selectIsRemoveModalOpen } from "../store/selectors";

const useJobRemoveModal = () => {
    const dispatch = useDispatch();

    const isRemoveModalOpen = useSelector(selectIsRemoveModalOpen);

    const handleOpenModal = useCallback(() => {
        dispatch(setRemoveModalOpen(true));
    }, []);

    const handleCloseModal = useCallback(() => {
        dispatch(setRemoveModalOpen(false));
    }, []);

    useUnmount(() => {
        handleCloseModal();
    });

    return { isOpen: isRemoveModalOpen, openModal: handleOpenModal, closeModal: handleCloseModal };
};

export default useJobRemoveModal;
